const Container = {
  sx: {
    flexGrow: 1,
    p: 3,
  },
};

const mainBody = {
  flex: 1,
  minWidth: 0,
  overflowX: "hidden",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

const SC = {
  Container,
  mainBody,
};

export default SC;
